import * as React from 'react';

import { type RowSelectionState } from '@tanstack/react-table';

import { useSidePanel } from 'src/registry/providers/SidePanelProvider';

type RowSelectionProps = {
    enableMultiRowSelection?: boolean;
    sidePanelName?: string; // This implies that if passed, we need to use sidePanel
};

function useRowSelection({ enableMultiRowSelection = false, sidePanelName }: RowSelectionProps = {}) {
    const [rowSelectionState, setRowSelectionState] = React.useState<RowSelectionState>({});

    const clearRowSelection = React.useCallback(() => {
        setRowSelectionState({});
    }, []);

    const { closePanel, openPanel } = useSidePanel();

    // Toggle the sidepanel after selection state has updated
    // Logic placed here for simplification and DRYness
    React.useEffect(() => {
        if (!sidePanelName) return;
        const firstSelected = Object.keys(rowSelectionState)[0];
        if (firstSelected) {
            openPanel(sidePanelName);
        } else {
            closePanel(sidePanelName);
        }
    }, [rowSelectionState, sidePanelName]);

    return {
        rowSelectionState,
        setRowSelectionState,
        clearRowSelection,
        enableMultiRowSelection,
    };
}

export default useRowSelection;
